export default "__VITE_ASSET__CDXGoGAI__"